// Reveal on scroll: every [data-reveal] element gets .is-revealed when it comes into view (once).
// Blocks set the look with CSS (e.g. .icon-benefits[data-reveal] .icon-benefit).
(() => {
  if (window.themeReveal) return;
  window.themeReveal = true;
  const show = (element) => element.classList.add('is-revealed');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal]').forEach(show);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      show(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  const watch = (root) => root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((element) => observer.observe(element));
  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
  document.addEventListener('shopify:block:select', (event) => event.target.closest?.('[data-reveal]') && show(event.target.closest('[data-reveal]')));
})();
